"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      tableData: [], // 列表数据
      searchData: {
        functionCode: '',
        page: 1, // 当前页码
        rows: 10 // 页码条数
      },
      newadd: false,
      title: '新增',
      addData: {
        id: '',
        functionCode: '',
        itemName: '',
        itemValue: '',
        used: '' },

      tableColumns: [
      {
        prop: 'itemName',
        label: '功能项名称',
        isShow: true },

      {
        prop: 'itemValue',
        label: '模型值',
        isShow: true }],


      defaultData: {
        id: '',
        functionCode: '',
        itemName: '',
        itemValue: '',
        used: '' },

      rules: {
        itemName: [{
          required: true,
          message: '请输入文件名称',
          trigger: 'blur' }],

        itemValue: [{
          required: true,
          message: '请输入文件名称',
          trigger: 'blur' }] },


      delIds: '' };

  },
  mounted: function mounted() {
    var self = this;
    self.searchData.functionCode = self.$route.params.parentId;
    self.defaultData.functionCode = self.$route.params.parentId;
    self.addData.functionCode = self.$route.params.parentId;
    self.init();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/deviceModelFuncItem/functioncode/' + self.searchData.functionCode, {}, function (res) {
        self.tableData = res;
        // if (self.tableData != null) {
        //   self.getData('/api/menu/button/pers', {}, function(res2) {
        //     for (var i = 0; i <= res2.length - 1; i++) {
        //       var first = res2[i]
        //       for (var j = 0; j < first.childs.length; j++) {
        //         var second = first.childs[j]
        //         for (var t = 0; t < second.childs.length; t++) {
        //           var third = second.childs[t]
        //           if (third.permission == 'firmwaredetail:list:add' && third.isPer) {
        //             $('.adddatail').addClass('hide')
        //           } else if (third.permission == 'firmwaredetail:list:updata' && third.isPer) {
        //             $('.updata').addClass('hide')
        //           } else if (third.permission == 'firmwaredetail:list:del1' && third.isPer) {
        //             $('.del1').addClass('hide')
        //             return
        //           }
        //         }
        //       }
        //     }
        //   })
        // }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/deviceModelFuncItem/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/model/modellist');
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/deviceModelFuncItem', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      console.log(item);
      this.addData = {
        id: item.id,
        itemName: item.itemName,
        itemValue: item.itemValue };

      self.newadd = true;
    },

    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/deviceModelFuncItem/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    } } };exports.default = _default;